import {Page, Text, View} from '@react-pdf/renderer';
import React from 'react';
import {yellow} from 'styles/constants';
import {Footer} from './Footer';
import {Header} from './Header';
import {styles} from './styles';

export const TextLine = ({children, ...props}) => {
	return <Text {...props}>{children}</Text>;
};

export const ValueTitle = ({children, style}) => {
	return (
		<Text
			style={{fontWeight: 600, textTransform: 'uppercase', marginBottom: '5px', ...style}}
		>
			{children}
		</Text>
	);
};

export const TextLineWithValue = ({text, value, styleProps}) => {
	return (
		<View
			style={{display: 'flex', flexDirection: 'row', marginTop: '4px', ...styleProps}}
		>
			<Text>{text}</Text>
			<Text
				style={{
					fontWeight: 600,
					position: 'relative',
					top: '-3px',
					left: '4px',
					fontSize: '14px',
				}}
			>
				{value}
			</Text>
		</View>
	);
};

export const LegendItem = ({text, color = '#999', textColor = 'black'}) => {
	return (
		<View style={{display: 'flex', flexDirection: 'row', marginBottom: 3}}>
			<View
				style={{
					position: 'relative',
					borderWidth: 1,
					borderColor: '#111',
					width: 15,
					height: 15,
					backgroundColor: color,
					left: -5,
				}}
			></View>
			<Text style={{color: textColor, fontSize: 10, marginTop: 1}}>{text}</Text>
		</View>
	);
};

export const MultiLineText = ({width = '100%', children, styleProps}) => {
	return <Text style={{width, ...styleProps}}>{children}</Text>;
};

export const Row = ({children, styleProps}) => {
	return (
		<View style={{display: 'flex', flexDirection: 'row', ...styleProps}}>{children}</View>
	);
};

export const RowItem = ({children, styleProps, width = '100%'}) => {
	return <View style={{width, ...styleProps}}>{children}</View>;
};

export const Pill = ({width, children}) => {
	return (
		<View
			style={{
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'center',
				backgroundColor: '#666',
				borderRadius: '999px',
				color: yellow,
				padding: '5px',
				paddingTop: '3px',
				paddingBottom: '3px',
				width,
				textAlign: 'center',
			}}
		>
			{children}
		</View>
	);
};

export const Hr = ({styleProps}) => (
	<View
		style={{
			height: '2px',
			borderTop: '1px',
			borderColor: '#666',
			width: '100%',
			marginTop: '12px',
			marginBottom: '12px',
			...styleProps,
		}}
	></View>
);

export const TextValuePill = ({width = '150px', text, value}) => {
	return (
		<Pill width={width}>
			<View style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
				<Text>{text}</Text>
				<ValueLarge styleProps={{marginLeft: '5px'}}>{value}</ValueLarge>
			</View>
		</Pill>
	);
};

export const HighlightBox = ({children, styleProps}) => {
	return (
		<View
			style={{
				backgroundColor: '#000',
				color: yellow,
				borderRadius: 3,
				padding: 10,
				width: '100%',
				textAlign: 'center',
				...styleProps,
			}}
		>
			{children}
		</View>
	);
};

export const ValueLarge = ({children, styleProps}) => {
	return (
		<Text style={{fontWeight: 600, fontSize: '15px', ...styleProps}}>{children}</Text>
	);
};

export const PageWithHeaderAndFooter = ({
	customer,
	pageTitle,
	showellUser,
	headerBackgroundImageUrl,
	footerBackgroundImageUrl,
	children,
}) => {
	return (
		<Page size="A4" style={styles.layout.page}>
			<Header
				customer={customer}
				background={headerBackgroundImageUrl}
				title={pageTitle}
			/>
			{children}
			<Footer showellUser={showellUser} backgroundUrl={footerBackgroundImageUrl} />
		</Page>
	);
};

/**
 * @param {array} values for example: ['25kg', '255 h', '600 tonnes']
 */
export const TableRow = ({title, values}) => {
	return (
		<Row styleProps={{marginTop: 5, borderBottom: 1, borderColor: '#999'}}>
			<RowItem width="30%">
				<Text>{title}</Text>
			</RowItem>
			<RowItem width="23%">
				<Text style={{}}>{values[0]}</Text>
			</RowItem>
			<RowItem width="23%">
				<Text style={{}}>{values[1]}</Text>
			</RowItem>
			<RowItem width="23%">
				<Text style={{fontWeight: 600, fontSize: 14}}>{values[2]}</Text>
			</RowItem>
		</Row>
	);
};

export const TableRowTwoCol = ({title, marginTop, children, noBorder = false}) => {
	return (
		<Row
			styleProps={{
				justifyContent: 'space-between',
				borderBottom: noBorder ? 0 : 1,
				borderColor: '#999',
				marginTop: marginTop ?? -3,
			}}
		>
			<RowItem>
				<Text style={{position: 'relative', top: 7, textAlign: 'left', fontSize: 10}}>
					{title}
				</Text>
			</RowItem>
			<RowItem width="50%">
				<Text
					style={{
						position: 'relative',
						top: 2,
						fontWeight: 600,
						textAlign: 'right',
						paddingRight: 5,
						fontSize: 14,
					}}
				>
					{children}
				</Text>
			</RowItem>
		</Row>
	);
};
